import React from "react";
import { Container, Row } from "react-bootstrap";

import responsiblesService from "presentation/services/responsibles";
import studentsService from "presentation/services/students";

import addressesService from "presentation/services/addresses";
import phonesService from "presentation/services/phones";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import ResponsibleForm from 'presentation/pages/responsibles/elements/form';

import { handleChange, getDocumentFieldType, getPhoneType, dateIsInvalid } from "presentation/utils/functions/generic";

import {
  mountItems
} from 'presentation/pages/persons/functions/phones';

import moment from "moment";

class ResponsibleEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
      phones: [],
      totalPhoneItems: 1,
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.loadData(id);
  }

  loadData = async (id) => {
    const { dependentId, studentId, academicPeriodId } = this.props.match.params;
    let responsibleInfo = {};

    let addressInfo = {};
    let phones = [];
    let totalPhoneItems = 1;

    await studentsService.findById(studentId).then((studentResult) => {
      if (!(studentResult.error == true)) {
        responsibleInfo.dependentId = dependentId;
        responsibleInfo.studentName = studentResult.person?.name;
        responsibleInfo.studentRegistration = studentResult.registration;
      }

    });

    await responsiblesService.findById(id).then(async (result) => {


      const { id: responsibleId, person: repsonbilePerson, insertAt: responsibleInsertAt, updateAt: responsibleUpdateAt, ...restOfResponsible } = result || {};
      const { id: personId, naturalPerson, student: personStudent, user: personUser, insertAt: personInsertAt, updateAt: personUpdateAt, ...restOfPerson } = result.person || {};
      const { id: naturalPersonId, insertAt: naturalPersonInsertAt, updateAt: naturalPersonUpdateAt, ...restOfNaturalPerson } = result.person?.naturalPerson || {};


      let responbileData = { ...restOfResponsible };

      responsibleInfo = {
        ...responsibleInfo,
        ...responbileData,
        registrationDate: moment(responbileData.registrationDate, 'YYYY-MM-DD').format("YYYY-MM-DD")
      }

      let genderId = typeof (result.person?.naturalPerson?.gender) === 'undefined' ? -1 : parseInt(result.person.naturalPerson?.gender);
      let bloodType = typeof (result.person?.naturalPerson?.bloodType) === 'undefined' ? -1 : parseInt(result.person.naturalPerson?.bloodType);

      let documentFieldTypeInfo = result.person.documentFieldType ? getDocumentFieldType(result.person.documentFieldType.toString().toLowerCase()) : undefined;
      let documentFieldTypeId = typeof (documentFieldTypeInfo) === 'undefined' ? -1 : documentFieldTypeInfo.id;

      let personInfo = { ...restOfPerson };
      let naturalPersonInfo = { ...restOfNaturalPerson };

      responsibleInfo = {
        ...responsibleInfo,
        personId: personId,
        naturalPersonId: naturalPersonId,
        ...personInfo,
        ...naturalPersonInfo,
        documentFieldType: documentFieldTypeId,
        gender: genderId,
        bloodType: bloodType,
        birthdate: naturalPersonInfo.birthdate != null ? moment(naturalPersonInfo?.birthdate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null,
        birthCertificateIssueDate: naturalPersonInfo.birthCertificateIssueDate != null ? moment(naturalPersonInfo?.birthCertificateIssueDate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null,
        rgIssueDate: naturalPersonInfo.rgIssueDate != null ? moment(naturalPersonInfo?.rgIssueDate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null
      }

      console.log(responsibleInfo);

      await addressesService.search({ personId: [responsibleInfo.personId] }).then((addressResult) => {
        const address = addressResult[0] || {};
        const { id: addressId, ...restOfAddress } = address;
        addressInfo = { ...restOfAddress };
      });

      await phonesService.search({ personId: responsibleInfo.personId }).then((phonesResult) => {
        if (!phonesResult?.error) {

          phones = phonesResult.map((e, i) => {
            var phoneTypeInfo = e?.phoneType ? getPhoneType(e?.phoneType.toString().toLowerCase()) : undefined;
            e.phoneType = typeof (phoneTypeInfo) === 'undefined' ? -1 : phoneTypeInfo.id;
            e.key = i + 1;
            return e;
          });

          totalPhoneItems = phones.length > 1 ? phones.length : 1;
        }

      });


    });
    this.setState({ form: responsibleInfo, studentId: studentId, dependentId: dependentId, academicPeriodId: academicPeriodId, addressForm: addressInfo, phones: phones, totalPhoneItems: totalPhoneItems, loading: false }, () => mountItems(this, phones, totalPhoneItems));
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {
    const { dependentId, studentId, academicPeriodId } = this.props.match.params;
    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
    } = this.state.form;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let addressData = this.state.addressForm || [];
      let phones = this.state.phones || [];

      let postData = this.state.form;
      postData.gender = "" + postData.gender;
      postData.bloodType = "" + postData.bloodType;
      postData.academicPeriodId = parseInt(academicPeriodId);

      let dateFields = ['birthdate', 'registrationDate', 'birthCertificateIssueDate', 'rgIssueDate'];
      dateFields.map((e, i) => {
        let dateValue = postData[e] || "";
        if (dateIsInvalid(dateValue)) {
          postData[e] = null;
        }
      });

      console.log(postData);

      try {
        const response = await responsiblesService.saveAssociated(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {

          if (!response.sameAddressAsStudent) {
            addressData.personId = response.personId;
            const addressResponse = await addressesService.save(addressData);
            if (addressResponse.error == true) {
              //TODO - notify
            }
          }

          if (phones.length > 0) {
            let phonesData = phones.map((e, i) => {
              e.personId = response.personId;
              return e;
            });

            const phonesResponse = await phonesService.batchManagement(phonesData);

            if (phonesResponse.error == true) {
              //TODO - notify
            }
          }


          this.goTo(`/responsaveis/${dependentId}/${studentId}`);
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form, dependentId, studentId, addressForm, phones } = this.state;
    let { handleSubmit } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <ResponsibleForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                dependentId={dependentId}
                studentId={studentId}
                loading={loading}
                form={form}
                addressForm={addressForm}
                phones={phones}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default ResponsibleEdit;
